import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Flex, Text } from "rebass";

import { changeRate } from "../../../store/modules/audio/actions";
import { getRate } from "../../../store/modules/audio/selectors";

import { MAX_SPEED, MIN_SPEED, STEP } from "../../constants/speed";

import { valueToRate, rateToValue } from "../../../utils/converSpeed";

import { RangeSlider } from "../styled/RangeSlider";

export const SpeedControl: React.FC = () => {
  const dispatch = useDispatch();
  const rate = useSelector(getRate);
  const [currentRate, setCurrentRate] = useState(rate);
  /*
  * IMPORTANT:
  * Wrong Type definitions for onChangeComplete(value: number)
  * Right Type definitions for onChangeComplete(event: Event)
  * node_modules/@types/react-rangeslider/index.d.ts:17
  * */
  const handleChangeComplete = useCallback(() => {
    dispatch(changeRate(valueToRate(currentRate)));
  }, [currentRate, dispatch]);
  const handleChange = useCallback((value: number) => {
    setCurrentRate(value);
  }, []);

  useEffect(() => {
    setCurrentRate(rateToValue(rate));
  }, [rate]);

  return (
    <Box>
      <Flex justifyContent="space-between">
        <Text
          fontSize="16px"
          fontWeight={600}
          lineHeight={1.19}
          color="zodiac"
          css="text-transform: capitalize;"
        >
          listening speed
        </Text>

        <Text
          fontWeight={600}
          lineHeight={1.19}
          color="#999cb8"
        >
          <Text
            as="span"
            fontSize="16px"
          >
            {currentRate}
          </Text>

          &nbsp;

          <Text
            as="span"
            fontSize="12px"
            css="text-transform: uppercase;"
          >
            wpm
          </Text>
        </Text>
      </Flex>

      <Box m="32px 0 13px">
        <RangeSlider
          min={MIN_SPEED}
          max={MAX_SPEED}
          value={currentRate}
          step={STEP}
          onChange={handleChange}
          onChangeComplete={handleChangeComplete}
          tooltip={false}
        />
      </Box>

      <Flex justifyContent="space-between">
        <Text
          fontSize="14px"
          fontWeight={600}
          lineHeight={1.36}
          color="#999cb8"
          css="text-transform: capitalize;"
        >
          slow
        </Text>

        <Text
          fontSize="14px"
          fontWeight={600}
          lineHeight={1.36}
          color="#999cb8"
          css="text-transform: capitalize;"
        >
          fast
        </Text>
      </Flex>
    </Box>
  );
};
